// Structured legal-document model. Content is transcribed 1:1 from the v1.0 PDF
// bundle at "MEC Vault/legal/app-legal/" — do not reword here; new legal language
// must come from a new PDF version.

export type LegalBlock =
  | { t: 'p'; text: string }
  | { t: 'h3'; text: string }
  | { t: 'ul'; items: string[] }
  | { t: 'ol'; items: string[] }
  | { t: 'note'; text: string }
  | { t: 'table'; head: string[]; rows: string[][] };

export interface LegalSection {
  id: string;
  number: string;
  title: string;
  blocks: LegalBlock[];
}

export interface LegalDoc {
  slug: string;
  title: string;
  version: string;
  updated: string;
  entity: string;
  seoDescription: string;
  sections: LegalSection[];
  closing?: string;
}

export interface LegalDocLink {
  slug: string;
  label: string;
}

// The published legal set — used for footer links and the "Otras políticas" cross-nav.
export const LEGAL_DOCS: LegalDocLink[] = [
  { slug: '/terminos', label: 'Términos de Servicio' },
  { slug: '/privacidad', label: 'Política de Privacidad' },
  { slug: '/articulos-prohibidos', label: 'Política de Artículos Prohibidos' },
  { slug: '/comunidad', label: 'Guías de la Comunidad' },
  { slug: '/derechos-autor', label: 'Derechos de Autor (DMCA)' },
  { slug: '/cookies', label: 'Política de Cookies' },
  { slug: '/privacidad-estatal', label: 'Derechos de Privacidad Estatales' },
];
